import React, { useState, useEffect, useRef } from 'react';

const ExperienceSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    {
      number: 10,
      suffix: "+",
      label: "Years Experience",
      color: "text-tango",
      duration: 2000
    },
    {
      number: 100,
      suffix: "+",
      label: "Happy Clients",
      color: "text-tango",
      duration: 2500
    },
    {
      number: 2,
      suffix: "",
      label: "Product Categories",
      color: "text-tango",
      duration: 1500
    },
    {
      number: 24,
      suffix: "/7",
      label: "Support Available",
      color: "text-tango",
      duration: 2000,
      isSpecial: true
    }
  ];

  // Intersection Observer to detect when section is visible
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 } // Trigger when 30% of section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-16 bg-gradient-to-r from-catalina-blue to-san-marino text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center mb-12">Our Experience & Range</h2>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className={`text-5xl md:text-6xl font-bold mb-2 ${stat.color}`}>
                <AnimatedCounter 
                  end={stat.number} 
                  suffix={stat.suffix}
                  duration={stat.duration}
                  isVisible={isVisible}
                  isSpecial={stat.isSpecial}
                />
              </div>
              <div className="text-lg md:text-xl text-gray-200">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Animated Counter Component
const AnimatedCounter = ({ end, suffix = "", duration = 2000, isVisible, isSpecial = false }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    let startTime;
    let animationFrame;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = (currentTime - startTime) / duration;

      if (progress < 1) {
        // Easing function for smooth animation (easeOutQuad)
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        setCount(Math.floor(end * easeProgress));
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [end, duration, isVisible]);

  return (
    <span>
      {count}{suffix}
    </span>
  );
};

export default ExperienceSection;